import { observer } from 'mobx-react-lite';
import React from 'react';
import { getMediaUploadSummary } from '../../../../data';
import { getPercentage } from '../../../../stores/utils';
import { ItemTitle, SVGCircle } from '../../index';
import { Chart, ChartContainer, LaneLabel, SmallChart } from '../Styles';

import { Popup } from 'semantic-ui-react';

const formatCommas = (value) => new Intl.NumberFormat().format(value);

export const LaneMediaUploads = observer(
  ({ auctionID, itemName, laneMetricList, onClick }) => {
    return (
      <>
        <ItemTitle
          testId="media-upload-label"
          textSize={1.5}
          titleText="Total Media Uploads"
        />
        <ChartContainer>
          {laneMetricList == null || laneMetricList.length == 0 ? (
            <LaneLabel>
              No per Lane Media Uploads Available for this Auction
            </LaneLabel>
          ) : (
            laneMetricList?.map((item) => (
              <Chart
                data-testid="auction-lane-chart-container"
                key={`chart_${item.laneID}`}
              >
                <SVGCircle
                  testId={`auction-lane-product-images-${item.laneID}`}
                  key={`svgcircle_${item.laneID}`}
                  auctionName={itemName}
                  laneName={item.laneName}
                  text={
                    formatCommas(item.laneTotalItemsUploaded) +
                    '/' +
                    formatCommas(item.laneTotalItems)
                  }
                  percentvalue={getPercentage(
                    item.laneTotalItemsUploaded,
                    item.laneTotalItems,
                  )}
                  chartError={item.laneTotalItemsError > 0}
                  auctionID={auctionID}
                  laneID={item.laneID}
                  onClick={() => onClick(item)}
                  popupHeader="Product Images"
                  popupPosition="left center"
                  clickRoute={`/auction/${auctionID}/lane/${item.laneID}/productImages`}
                />

                <Popup
                  data-testid="auction-lane-products-popup"
                  key={`prod_popup_${item.laneName}`}
                  content={`The ${
                    item.laneName
                  } lane has a total of ${formatCommas(
                    item.laneTotalUnits,
                  )} units, which you can click to view a list of them.`}
                  header="Lane Products"
                  size="tiny"
                  trigger={
                    <LaneLabel
                      data-testid="auction-lane-products-wrapper"
                      style={{ cursor: 'pointer' }}
                      bold
                      onClick={() => onClick(item)}
                    >
                      <h3>{formatCommas(item.laneTotalUnits)} UNITS</h3>
                      {item.laneName}
                    </LaneLabel>
                  }
                />
              </Chart>
            ))
          )}
        </ChartContainer>
      </>
    );
  },
);

export default LaneMediaUploads;
